import Stepper from 'components/ui/Stepper';
import { useAppContext } from 'context/useAppContext';

const Header = () => {
  const { currentStep, setStep } = useAppContext();

  const steps = [
    { label: 'Customer Details' },
    { label: 'KYC & Repayment Details' },
  ];

  return (
    <header className="w-full space-y-8">
      <div className="flex items-center justify-center gap-2">
        <p className="text-gray-600 text-xl">Powered by</p>
        <img
          src="/ceviant_logo.svg"
          alt="logo"
        />{' '}
      </div>
      <div>
        <p className="font-semibold font-grotesk text-xl md:text-2xl lg:text-4xl text-center md:mb-2">
          Lock In Your Fare Now, Pay Later with Ease
        </p>
        <Stepper
          steps={steps}
          currentStep={currentStep}
          allowClickNavigation
          onStepClick={(step) => setStep(step)}
        />
      </div>
    </header>
  );
};

export default Header;
